export default "__VITE_ASSET__B60BWWNl__";